import { Alert, Button, Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

/** Shown to a PRO subscriber at an All-Access-only gate — acknowledges their
 *  active plan instead of the free-user "Unlock with All Access" copy. */
export default function ProUpsellNote() {
  const { t } = useTranslation("common");
  return (
    <Alert severity="info" sx={{ my: 2 }} icon={false}>
      <Box sx={{ fontWeight: 600, mb: 0.5 }}>{t("ProUpsellNote.included")}</Box>
      {t("ProUpsellNote.body")}
      <Box sx={{ mt: 1.5 }}>
        <Button component={RouterLink} to="/pricing" variant="contained" size="small">
          {t("ProUpsellNote.upgrade")}
        </Button>
      </Box>
    </Alert>
  );
}
